import { getCookie } from "@insite/client-framework/Common/Cookies";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import LoadingSpinner from "@insite/mobius/LoadingSpinner";
import { HasHistory, withHistory } from "@insite/mobius/utilities/HistoryContext";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { FC, useState } from "react";
import { css } from "styled-components";

export interface ContainerStyles {
    container?: InjectableCss;
    loadingWrapper?: InjectableCss;
}

const styles: ContainerStyles = {
    container: {
        css: css``,
    },
    loadingWrapper: {
        css: css`
            width: 100vw;
            height: 100vh;
            z-index: 100;
            position: fixed;
            top: 0;
            left: 0;
            background-color: white;
            display: flex;
            justify-content: center;
            align-items: center;
        `,
    },
};

type Props = WidgetProps & HasHistory;

const CrescentCustomContainer: FC<Props> = ({ id, history }) => {
    const [showBenefitContent, setShowBenefitContent] = useState(false);
    const [benefitGuideLoading, setBenefitGuideLoading] = useState(false);
    React.useEffect(() => {
        const isBenefitPageAuthenticated = getCookie("isBenefitPageAuthenticated");

        if (!isBenefitPageAuthenticated) {
            // eslint-disable-next-line no-restricted-globals
            history.replace("/BenefitProtected");
        } else {
            setShowBenefitContent(true);
            setBenefitGuideLoading(true);
        }
    }, []);

    return (
        <>
            {!benefitGuideLoading && (
                <StyledWrapper {...styles.loadingWrapper}>
                    <LoadingSpinner />
                </StyledWrapper>
            )}
            <StyledWrapper {...styles.container}>
                {showBenefitContent && <Zone zoneName="Content" contentId={id} />}
            </StyledWrapper>
        </>
    );
};

const widgetModule: WidgetModule = {
    component: withHistory(CrescentCustomContainer),
    definition: {
        group: "Common",
        displayName: "Benefits Guide",
    },
};

export default widgetModule;
